(function() {
  'use strict';

  // Feature Icons Mapping
  const FEATURE_ICONS = {
    'Self-Serve Car Wash': `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12 3c-1.25 0-2.45.2-3.57.57L7 10h10l-1.43-6.43C14.45 3.2 13.25 3 12 3m1 2.41c.59 0 1 .41 1 1 0 .59-.41 1-1 1s-1-.41-1-1c0-.59.41-1 1-1M9 19c0 1.11.89 2 2 2s2-.89 2-2v-3H9v3m-2-9v3h10v-3H7m13 6v-2h-3v2h-2v-2h-4v2H9v-2H6v2H4v-2H2v6h20v-6h-2z"/></svg>`,
    'Automatic Car Wash': `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M5,15C3.34,15 2,16.34 2,18A3,3 0 0,0 5,21C6.66,21 8,19.66 8,18C8,16.34 6.66,15 5,15M19,15C17.34,15 16,16.34 16,18A3,3 0 0,0 19,21C20.66,21 22,19.66 22,18C22,16.34 20.66,15 19,15M17.5,9.5H16L14,7H10L8,9.5H6.5C5.67,9.5 5,10.17 5,11V13H19V11C19,10.17 18.33,9.5 17.5,9.5M10.5,7.5H13.5L14.5,9H9.5L10.5,7.5M12,2C6.48,2 2,6.48 2,12H4C4,7.58 7.58,4 12,4C16.42,4 20,7.58 20,12H22C22,6.48 17.52,2 12,2Z"/></svg>`,
    'Touchless': `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M11,9H13V11H11M9,9H11V11H9M15,9H13V11H15M17,9H15V11H17M7,9H9V11H7M7.5,15V17H16.5V15M7.5,13H16.5V15H7.5M20,10C20,8 19,7 17,7H7C5,7 4,8 4,10V18C4,20 5,21 7,21H17C19,21 20,20 20,18M12,3C9.61,3 7.35,3.71 5.5,5.09C5.03,5.42 4.96,6.08 5.29,6.55C5.62,7.03 6.28,7.1 6.75,6.77C8.29,5.6 10.09,5 12,5C13.91,5 15.71,5.6 17.25,6.77C17.72,7.1 18.38,7.03 18.71,6.55C19.04,6.08 18.97,5.42 18.5,5.09C16.65,3.71 14.39,3 12,3Z"/></svg>`,
    'Free Vacuums': `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M7,22H9V24H7V22M11,22H13V24H11V22M15,22H17V24H15V22M2,10H4V20H2V10M20,10H22V20H20V10M12,0C9.8,0 8,1.8 8,4V8H16V4C16,1.8 14.2,0 12,0M6,10V20H18V10H6Z"/></svg>`,
    'Pet Wash': `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M18,4C16.29,4 15.25,4.33 14.65,4.61C13.88,4.23 13,4 12,4C11,4 10.12,4.23 9.35,4.61C8.75,4.33 7.71,4 6,4C3,4 1,12 1,14C1,14.83 2.32,15.59 4.14,15.9C4.78,18.14 7.8,19.85 11.5,20V15.72C10.91,15.35 10,14.68 10,14C10,13 11,13 12,13C13,13 14,13 14,14C14,14.68 13.09,15.35 12.5,15.72V20C16.2,19.85 19.22,18.14 19.86,15.9C21.68,15.59 23,14.83 23,14C23,12 21,4 18,4Z"/></svg>`,
    '24/7': `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12,2A10,10 0 0,0 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M16.2,16.2L11,13V7H12.5V12.2L17,14.9L16.2,16.2Z"/></svg>`,
    'Credit Card': `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M20,8H4V6H20M20,18H4V12H20M20,4H4C2.89,4 2,4.89 2,6V18A2,2 0 0,0 4,20H20A2,2 0 0,0 22,18V6C22,4.89 21.1,4 20,4Z"/></svg>`,
    'Loyalty Program': `<svg viewBox="0 0 24 24" fill="currentColor"><path d="M12,17.27L18.18,21L16.54,13.97L22,9.24L14.81,8.62L12,2L9.19,8.62L2,9.24L7.45,13.97L5.82,21L12,17.27Z"/></svg>`
  };

  // Get feature icon SVG
  function getFeatureIcon(featureName) {
    const key = Object.keys(FEATURE_ICONS).find(k =>
      featureName.toLowerCase().includes(k.toLowerCase()) ||
      k.toLowerCase().includes(featureName.toLowerCase())
    );
    return key ? FEATURE_ICONS[key] : null;
  }

  // Initialize all store locator sections on the page
  function initAllStoreLocators() {
    // Find all config script tags
    const configScripts = document.querySelectorAll('script[type="application/json"][id^="StoreLocatorConfig-"]');
    
    configScripts.forEach(function(configScript) {
      const sectionId = configScript.id.replace('StoreLocatorConfig-', '');
      
      try {
        const config = JSON.parse(configScript.textContent);
        const dataScript = document.getElementById('StoreLocatorData-' + sectionId);
        
        if (!dataScript) {
          console.warn('Store Locator: Location data script tag not found for section', sectionId);
          return;
        }
        
        const rawData = JSON.parse(dataScript.textContent);
        initStoreLocator(sectionId, config, rawData);
      } catch (error) {
        console.error('Store Locator: Error initializing section', sectionId, error);
      }
    });
  }

  // Helper function to parse schedule metaobject fields into hours object
  function parseScheduleFields(fields) {
    if (!fields || !Array.isArray(fields)) return null;
    
    const fieldMap = {};
    fields.forEach(field => {
      fieldMap[field.key] = field.value;
    });
    
    const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
    const hours = {};
    
    // Check if 24/7 (handle both string and boolean)
    if (fieldMap.is_24_7 === 'true' || fieldMap.is_24_7 === true) {
      days.forEach(day => {
        hours[day] = 'Open 24 Hours';
      });
      return hours;
    }
    
    // Build hours for each day
    days.forEach(day => {
      const closedKey = `${day}_closed`;
      const openKey = `${day}_open`;
      const closeKey = `${day}_close`;
      
      // Handle both string and boolean for closed status
      if (fieldMap[closedKey] === 'true' || fieldMap[closedKey] === true) {
        hours[day] = 'Closed';
      } else {
        const open = fieldMap[openKey] || '';
        const close = fieldMap[closeKey] || '';
        if (open && close) {
          hours[day] = `${open} - ${close}`;
        } else if (open) {
          hours[day] = open;
        } else {
          hours[day] = 'Closed';
        }
      }
    });
    
    return hours;
  }

  // Initialize a single store locator instance
  function initStoreLocator(sectionId, config, rawData) {
    // Load location data
    let locations = [];
    
    if (rawData && Array.isArray(rawData)) {
      try {
        // Convert coordinates to numbers and ensure all fields are present
        locations = rawData.map(function(loc) {
          // Parse coordinates, ensuring longitude is negative for US locations
          let lat = parseFloat(loc.lat) || 0;
          let lng = parseFloat(loc.lng) || 0;
          
          // Fix longitude if it's positive (US longitudes should be negative)
          // Ohio is around -81 to -85, so if we have +81, it's likely a data entry error
          if (lng > 0 && lng < 180 && Math.abs(lng) > 70) {
            console.warn(`Location "${loc.name}": Converting positive longitude ${lng} to negative`);
            lng = -Math.abs(lng);
          }
          
          // Build categories array from metaobject references
          let categories = [];
          if (loc.categories && Array.isArray(loc.categories)) {
            // New relational structure: array of category objects with {name, slug}
            categories = loc.categories.map(cat => {
              // Handle both object format and string format for backward compatibility
              return typeof cat === 'object' ? cat.name : cat;
            });
          } else if (loc.category) {
            // Legacy structure: single category
            categories = [loc.category];
          }
          
          // Debug logging for Chardon location
          if (loc.name && loc.name.includes('Chardon')) {
            console.log(`📍 ${loc.name}: Categories →`, categories);
          }
          
          // Build hours object from metaobject schedules or legacy formats
          let hours = {};
          
          if (loc.schedules) {
            // New metaobject schedule format
            const serviceMap = {
              'carWash': 'Car Wash',
              'detailing': 'Auto Detailing',
              'careCenter': 'Auto Care Center',
              'gasStore': 'Gas Store',
              'retail': 'Retail Store'
            };
            
            Object.keys(serviceMap).forEach(key => {
              const schedule = loc.schedules[key];
              if (schedule && Array.isArray(schedule)) {
                const parsedHours = parseScheduleFields(schedule);
                if (parsedHours) {
                  const categoryName = serviceMap[key];
                  hours[categoryName] = parsedHours;
                  
                  // Also store under any matching category variations
                  categories.forEach(cat => {
                    if (cat.toLowerCase().replace(/\s+/g, '') === categoryName.toLowerCase().replace(/\s+/g, '')) {
                      hours[cat] = parsedHours;
                    }
                  });
                  
                  // Debug logging for Chardon location
                  if (loc.name && loc.name.includes('Chardon')) {
                    console.log(`✅ ${loc.name}: Found ${key} schedule →`, categoryName, parsedHours);
                  }
                } else if (loc.name && loc.name.includes('Chardon')) {
                  console.warn(`⚠️ ${loc.name}: ${key} schedule exists but failed to parse`);
                }
              } else if (loc.name && loc.name.includes('Chardon')) {
                console.log(`ℹ️ ${loc.name}: No ${key} schedule found`);
              }
            });
          } else if (loc.hours && typeof loc.hours === 'object' && loc.hours['Car Wash'] && typeof loc.hours['Car Wash'] === 'object') {
            // Old JSON structure: hours per category
            hours = loc.hours;
          } else if (loc.hours && typeof loc.hours === 'object' && loc.hours.monday !== undefined) {
            // Legacy structure: single hours object, apply to all categories or first category
            const legacyHours = loc.hours;
            if (categories.length > 0) {
              // Apply to all categories
              categories.forEach(cat => {
                hours[cat] = legacyHours;
              });
            } else {
              // No categories, use default
              hours['default'] = legacyHours;
            }
          }
          
          // Parse features from metaobject references
          let features = [];
          if (loc.features && Array.isArray(loc.features)) {
            // New relational structure: array of feature objects with {name, slug}
            features = loc.features.map(feat => {
              // Handle both object format and string format for backward compatibility
              return typeof feat === 'object' ? feat.name : feat;
            });
          } else if (loc.features && typeof loc.features === 'string') {
            // Legacy structure: comma-separated string
            features = loc.features.split(',').map(f => f.trim()).filter(f => f.length > 0);
          }
          
          // Final debug logging for Chardon location
          if (loc.name && loc.name.includes('Chardon')) {
            console.log(`🕐 ${loc.name}: Final hours object →`, hours);
          }

          return {
            name: loc.name || '',
            address1: loc.address1 || '',
            address2: loc.address2 || '',
            city: loc.city || '',
            state: loc.state || '',
            zip: loc.zip || '',
            lat: lat,
            lng: lng,
            phone: loc.phone || '',
            servicePage: ({'zappys-auto-care-center':'/pages/auto-care-center','zappys-gas-store':'/pages/gas-store','zappys-auto-detail-shop':'/pages/retail-store'})[loc.handle] || '',
            categories: categories,
            services: loc.services || '',
            features: features,
            hours: hours
          };
        });
        console.log('Store Locator: Loaded', locations.length, 'locations');
        // Log first location coordinates for debugging
        if (locations.length > 0) {
          console.log('Sample location coordinates:', {
            name: locations[0].name,
            lat: locations[0].lat,
            lng: locations[0].lng
          });
        }
      } catch (error) {
        console.error('Store Locator: Error parsing location data', error);
      }
    } else {
      console.warn('Store Locator: No locations found. Make sure location blocks are added in the theme editor.');
    }

    // Calculate distance between two coordinates (Haversine formula)
    function calculateDistance(lat1, lng1, lat2, lng2) {
      const R = 3959; // Earth's radius in miles
      const dLat = (lat2 - lat1) * Math.PI / 180;
      const dLng = (lng2 - lng1) * Math.PI / 180;
      const a = 
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(lat1 * Math.PI / 180) * Math.cos(lat2 * Math.PI / 180) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);
      const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
      return R * c;
    }

    // Format distance for display
    function formatDistance(distance) {
      if (distance < 0.1) {
        return (distance * 5280).toFixed(0) + ' ft away';
      } else if (distance < 1) {
        return (distance * 5280).toFixed(0) + ' ft away';
      } else {
        return distance.toFixed(1) + ' miles away';
      }
    }

    // Get user location and sort by distance
    let userLocation = null;

    function getUserLocation() {
      if (!navigator.geolocation) {
        console.log('Geolocation is not supported by this browser.');
        return Promise.resolve(null);
      }

      return new Promise((resolve) => {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            userLocation = {
              lat: position.coords.latitude,
              lng: position.coords.longitude
            };
            console.log('User location detected:', userLocation);
            console.log('User location accuracy:', position.coords.accuracy, 'meters');
            resolve(userLocation);
          },
          (error) => {
            // Handle different error types
            if (error.code === 1) {
              console.log('Geolocation permission denied by user.');
            } else if (error.code === 2) {
              console.log('Geolocation position unavailable.');
            } else if (error.code === 3) {
              console.log('Geolocation request timed out.');
            } else {
              console.log('Geolocation error:', error.message);
            }
            resolve(null);
          },
          {
            enableHighAccuracy: true, // Use more accurate GPS if available
            timeout: 10000, // Increased timeout to 10 seconds
            maximumAge: 300000 // Cache for 5 minutes
          }
        );
      });
    }

    // Sort locations by distance from search origin (searchLocation or userLocation)
    function sortLocationsByDistance(locs, searchLoc = null) {
      // Use searchLocation if available (from autocomplete), otherwise use userLocation
      const originLocation = searchLoc || userLocation;
      
      if (!originLocation) {
        console.log('sortLocationsByDistance: No search origin or user location, returning unsorted');
        return locs;
      }

      const sorted = locs.map(location => {
        const distance = calculateDistance(
          originLocation.lat,
          originLocation.lng,
          location.lat,
          location.lng
        );
        
        return {
          ...location,
          distance: distance
        };
      }).sort((a, b) => (a.distance || Infinity) - (b.distance || Infinity));
      
      return sorted;
    }

    // Check if location is currently open based on hours
    function isLocationOpen(hours) {
      const now = new Date();
      const currentDay = now.getDay(); // 0 = Sunday, 1 = Monday, etc.
      const currentTime = now.getHours() * 60 + now.getMinutes(); // Time in minutes

      const dayMap = {
        0: 'sunday',
        1: 'monday',
        2: 'tuesday',
        3: 'wednesday',
        4: 'thursday',
        5: 'friday',
        6: 'saturday'
      };
      const dayNames = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];

      const todayHours = hours[dayMap[currentDay]] || '';
      
      // Handle 24/7 hours (check for both "24/7" and "Open 24 Hours" formats)
      const lowerHours = todayHours.toLowerCase();
      if (todayHours && (lowerHours.includes('24 hours') || lowerHours.includes('24/7') || lowerHours === 'open 24 hours')) {
        return { isOpen: true, statusText: 'Open 24 Hours', nextOpen: null };
      }

      // Parse hours (format: "9:00 AM - 5:00 PM" or "9AM - 5PM")
      const hoursMatch = todayHours.match(/(\d{1,2}):?(\d{2})?\s*(AM|PM)\s*-\s*(\d{1,2}):?(\d{2})?\s*(AM|PM)/i);
      
      // If today is closed or no hours, find next open day
      if (!todayHours || todayHours.toLowerCase() === 'closed' || !hoursMatch) {
        // Search for next open day (up to 7 days ahead)
        for (let dayOffset = 1; dayOffset <= 7; dayOffset++) {
          const checkDay = (currentDay + dayOffset) % 7;
          const checkDayHours = hours[dayMap[checkDay]] || '';
          const checkLower = checkDayHours.toLowerCase();
          const is24Hours = checkDayHours && (checkLower.includes('24 hours') || checkLower.includes('24/7') || checkLower === 'open 24 hours');
          
          if (checkDayHours && checkLower !== 'closed' && !is24Hours) {
            const nextHoursMatch = checkDayHours.match(/(\d{1,2}):?(\d{2})?\s*(AM|PM)\s*-\s*(\d{1,2}):?(\d{2})?\s*(AM|PM)/i);
            if (nextHoursMatch) {
              const openTimeStr = nextHoursMatch[1] + (nextHoursMatch[2] ? ':' + nextHoursMatch[2] : '') + ' ' + nextHoursMatch[3];
              const dayName = dayOffset === 1 ? 'tomorrow' : dayNames[checkDay].toLowerCase();
              return { 
                isOpen: false, 
                statusText: 'Closed', 
                nextOpen: `Opens ${dayName} at ${openTimeStr}`
              };
            }
          } else if (is24Hours) {
            const dayName = dayOffset === 1 ? 'tomorrow' : dayNames[checkDay].toLowerCase();
            return { 
              isOpen: false, 
              statusText: 'Closed', 
              nextOpen: `Opens ${dayName}`
            };
          }
        }
        return { isOpen: false, statusText: 'Closed', nextOpen: null };
      }

      const openHour = parseInt(hoursMatch[1]);
      const openMinute = parseInt(hoursMatch[2] || '0');
      const openPeriod = hoursMatch[3].toUpperCase();
      const closeHour = parseInt(hoursMatch[4]);
      const closeMinute = parseInt(hoursMatch[5] || '0');
      const closePeriod = hoursMatch[6].toUpperCase();

      let openTime = openHour * 60 + openMinute;
      if (openPeriod === 'PM' && openHour !== 12) openTime += 12 * 60;
      if (openPeriod === 'AM' && openHour === 12) openTime -= 12 * 60;

      let closeTime = closeHour * 60 + closeMinute;
      if (closePeriod === 'PM' && closeHour !== 12) closeTime += 12 * 60;
      if (closePeriod === 'AM' && closeHour === 12) closeTime -= 12 * 60;

      // Handle case where close time is next day (e.g., 11 PM - 2 AM)
      if (closeTime < openTime) {
        closeTime += 24 * 60;
        if (currentTime < openTime) {
          // Before opening today
          const openTimeStr = hoursMatch[1] + (hoursMatch[2] ? ':' + hoursMatch[2] : '') + ' ' + hoursMatch[3];
          return { isOpen: false, statusText: 'Closed', nextOpen: `Opens at ${openTimeStr}` };
        }
        // After midnight, check if still open
        const adjustedCurrentTime = currentTime + (currentTime < openTime ? 24 * 60 : 0);
        const isOpen = adjustedCurrentTime >= openTime && adjustedCurrentTime <= closeTime;
        if (isOpen) {
          return { isOpen: true, statusText: 'Open', nextOpen: null };
        } else {
          // Find next open day
          for (let dayOffset = 1; dayOffset <= 7; dayOffset++) {
            const checkDay = (currentDay + dayOffset) % 7;
            const checkDayHours = hours[dayMap[checkDay]] || '';
            
            if (checkDayHours && checkDayHours.toLowerCase() !== 'closed' && !checkDayHours.toLowerCase().includes('24/7')) {
              const nextHoursMatch = checkDayHours.match(/(\d{1,2}):?(\d{2})?\s*(AM|PM)\s*-\s*(\d{1,2}):?(\d{2})?\s*(AM|PM)/i);
              if (nextHoursMatch) {
                const openTimeStr = nextHoursMatch[1] + (nextHoursMatch[2] ? ':' + nextHoursMatch[2] : '') + ' ' + nextHoursMatch[3];
                const dayName = dayOffset === 1 ? 'tomorrow' : dayNames[checkDay].toLowerCase();
                return { 
                  isOpen: false, 
                  statusText: 'Closed', 
                  nextOpen: `Opens ${dayName} at ${openTimeStr}`
                };
              }
            } else if (checkDayHours && checkDayHours.toLowerCase().includes('24/7')) {
              const dayName = dayOffset === 1 ? 'tomorrow' : dayNames[checkDay].toLowerCase();
              return { 
                isOpen: false, 
                statusText: 'Closed', 
                nextOpen: `Opens ${dayName}`
              };
            }
          }
          return { isOpen: false, statusText: 'Closed', nextOpen: null };
        }
      }

      const isOpen = currentTime >= openTime && currentTime <= closeTime;
      if (isOpen) {
        return { isOpen: true, statusText: 'Open', nextOpen: null };
      } else {
        // Closed for today - check if opens later today or next day
        if (currentTime < openTime) {
          // Opens later today
          const openTimeStr = hoursMatch[1] + (hoursMatch[2] ? ':' + hoursMatch[2] : '') + ' ' + hoursMatch[3];
          return { isOpen: false, statusText: 'Closed', nextOpen: `Opens at ${openTimeStr}` };
        } else {
          // Closed for today, find next open day
          for (let dayOffset = 1; dayOffset <= 7; dayOffset++) {
            const checkDay = (currentDay + dayOffset) % 7;
            const checkDayHours = hours[dayMap[checkDay]] || '';
            
            if (checkDayHours && checkDayHours.toLowerCase() !== 'closed' && !checkDayHours.toLowerCase().includes('24/7')) {
              const nextHoursMatch = checkDayHours.match(/(\d{1,2}):?(\d{2})?\s*(AM|PM)\s*-\s*(\d{1,2}):?(\d{2})?\s*(AM|PM)/i);
              if (nextHoursMatch) {
                const openTimeStr = nextHoursMatch[1] + (nextHoursMatch[2] ? ':' + nextHoursMatch[2] : '') + ' ' + nextHoursMatch[3];
                const dayName = dayOffset === 1 ? 'tomorrow' : dayNames[checkDay].toLowerCase();
                return { 
                  isOpen: false, 
                  statusText: 'Closed', 
                  nextOpen: `Opens ${dayName} at ${openTimeStr}`
                };
              }
            } else if (checkDayHours && checkDayHours.toLowerCase().includes('24/7')) {
              const dayName = dayOffset === 1 ? 'tomorrow' : dayNames[checkDay].toLowerCase();
              return { 
                isOpen: false, 
                statusText: 'Closed', 
                nextOpen: `Opens ${dayName}`
              };
            }
          }
          return { isOpen: false, statusText: 'Closed', nextOpen: null };
        }
      }
    }

    // Get config values
    const brandColor = config.brandColor || '#15226b';
    const brandLogoUrl = config.brandLogoUrl || null;
    const markerColorUnselected = config.markerColorUnselected || '#15226b';
    const markerColorHovered = config.markerColorHovered || '#6b7280';
    const markerColorSelected = config.markerColorSelected || '#2563eb';
    const markerSizeUnselected = config.markerSizeUnselected || 20;
    const markerSizeHovered = config.markerSizeHovered || 20;
    const markerSizeSelected = config.markerSizeSelected || 50;
    const markerLogoSize = config.markerLogoSize || 30;
    const mapBoundsPadding = config.mapBoundsPadding || 50;
    const googleMapsMapId = config.googleMapsMapId || 'DEMO_MAP_ID';
    const googleMapsApiKey = config.googleMapsApiKey || '';

    // Parse available features from config
    const availableFeatures = config.availableFeatures ?
      config.availableFeatures.split('\n').map(f => f.trim()).filter(f => f.length > 0) : [];

    // Initialize store locator
    async function startStoreLocator() {
      const searchInput = document.getElementById('store-search-' + sectionId);
      const categoryPills = document.querySelectorAll('#store-categories-' + sectionId + ' .store-locator__category-pill');
      const filterBtn = document.getElementById('store-filter-btn-' + sectionId);
      const filterPanel = document.getElementById('store-filter-panel-' + sectionId);
      const filterFeaturesContainer = document.getElementById('store-filter-features-' + sectionId);
      const filterClearBtn = document.getElementById('store-filter-clear-' + sectionId);
      const filterApplyBtn = document.getElementById('store-filter-apply-' + sectionId);
      const listContainer = document.getElementById('store-list-' + sectionId);
      const mapContainer = document.getElementById('store-map-' + sectionId);
      const locationBtn = document.getElementById('store-location-btn-' + sectionId);

      if (!searchInput || !listContainer || !mapContainer) {
        console.error('Store Locator: Required DOM elements not found', {
          searchInput: !!searchInput,
          listContainer: !!listContainer,
          mapContainer: !!mapContainer,
          sectionId: sectionId
        });
        return;
      }

      console.log('Store Locator: Initializing with', locations.length, 'locations');

      let filteredLocations = [...locations];
      let selectedCategory = ''; // Currently selected category
      let selectedFeatures = []; // Currently selected features
      let selectedLocation = null;
      
      // Do NOT request geolocation on page load - only when user clicks "Use my location"
      console.log('Store Locator initialized. Locations will display in default order until user searches or uses location.');

      // Render location cards
      function renderLocations(locs) {
        if (!listContainer) return;
        
        listContainer.innerHTML = '';
        
        if (locs.length === 0) {
          listContainer.innerHTML = '<div class="store-locator__no-results"><p>No locations found. Please try a different search.</p></div>';
          return;
        }

        // Get current category filter to determine which hours to show
        const categoryFilter = selectedCategory || '';
        
        locs.forEach((location, index) => {
          // Get hours for the filtered category (or first category if no filter)
          const displayCategory = categoryFilter || (location.categories && location.categories.length > 0 ? location.categories[0] : null);
          const locationHours = getHoursForCategory(location, displayCategory);
          
          // Build status text showing each category's status
          let categoryStatuses = [];
          let overallStatus = 'closed';
          let displayStatus = '';
          const hasMultipleCategories = location.categories && location.categories.length > 1;
          
          if (location.categories && location.categories.length > 0) {
            let openServices = [];
            let closedServices = [];
            let earliestNextOpen = null;
            
            location.categories.forEach(cat => {
              const catHours = getHoursForCategory(location, cat);
              if (catHours) {
                const catStatus = isLocationOpen(catHours);
                if (catStatus.isOpen) {
                  openServices.push(cat);
                  overallStatus = 'open';
                } else {
                  closedServices.push({ name: cat, nextOpen: catStatus.nextOpen });
                  // Track earliest next open time
                  if (catStatus.nextOpen && !earliestNextOpen) {
                    earliestNextOpen = catStatus.nextOpen;
                  }
                }
              }
            });
            
            // Build simplified status for multi-category locations
            if (hasMultipleCategories) {
              if (openServices.length > 0 && closedServices.length > 0) {
                // Some services open, some closed
                displayStatus = `${openServices.join(', ')}: Open • ${closedServices.map(s => s.name).join(', ')}: Closed`;
              } else if (openServices.length > 0) {
                // All services open
                displayStatus = 'Open';
              } else if (earliestNextOpen) {
                // All closed, show earliest opening time
                displayStatus = `Closed - ${earliestNextOpen}`;
              } else {
                displayStatus = 'Closed';
              }
            } else {
              // Single category - show full status
              if (openServices.length > 0) {
                const catStatus = isLocationOpen(getHoursForCategory(location, openServices[0]));
                displayStatus = catStatus.statusText;
              } else if (closedServices.length > 0 && closedServices[0].nextOpen) {
                displayStatus = `Closed - ${closedServices[0].nextOpen}`;
              } else {
                displayStatus = 'Closed';
              }
            }
          } else {
            // Fallback to single status if no categories
            const status = locationHours ? isLocationOpen(locationHours) : { isOpen: false, statusText: 'Hours not available', nextOpen: null };
            if (status.isOpen) {
              displayStatus = status.statusText;
              overallStatus = 'open';
            } else {
              displayStatus = status.nextOpen ? `Closed - ${status.nextOpen}` : status.statusText;
            }
          }
          
          const card = document.createElement('div');
          card.className = 'store-locator__card';
          card.setAttribute('role', 'listitem');
          card.setAttribute('data-location-index', index);
          card.setAttribute('data-lat', location.lat);
          card.setAttribute('data-lng', location.lng);
          card.setAttribute('data-status', overallStatus);
          
          // Build short address for card (address1 + address2 only)
          const shortAddressParts = [location.address1];
          if (location.address2) shortAddressParts.push(location.address2);
          const shortAddress = shortAddressParts.join(', ');
          
          // Build full address with all available fields for details and directions
          const fullAddressParts = [location.address1];
          if (location.address2) fullAddressParts.push(location.address2);
          if (location.city || location.state || location.zip) {
            const cityStateZip = [location.city, location.state, location.zip].filter(Boolean).join(' ');
            if (cityStateZip) fullAddressParts.push(cityStateZip);
          }
          const fullAddress = fullAddressParts.join(', ');
          const googleMapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(fullAddress)}`;
          const dayNames = ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'];
          const dayKeys = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
          const distanceText = location.distance !== undefined ? formatDistance(location.distance) : '';
          const distanceStatusText = distanceText ? `${distanceText} · ${displayStatus}` : displayStatus;

          card.innerHTML = `
            <div class="store-locator__card-main">
              <div class="store-locator__card-header">
                <div class="store-locator__card-title-wrapper">
                  <h3 class="store-locator__card-title">${escapeHtml(location.name)}</h3>
                  <button 
                    type="button" 
                    class="store-locator__card-info-btn" 
                    aria-label="Toggle location details"
                    aria-expanded="false"
                    data-location-id="${index}"
                  >
                    <svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" fill="none">
                      <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" fill="currentColor"/>
                    </svg>
                  </button>
                </div>
                ${location.categories && location.categories.length > 0 ? '<div class="store-locator__card-types">' + location.categories.map(cat => `<span class="store-locator__card-type">${escapeHtml(cat)}</span>`).join('') + '</div>' : ''}
              </div>
              <div class="store-locator__card-body">
                <p class="store-locator__card-address">${escapeHtml(shortAddress)}</p>
                <p class="store-locator__card-distance-status">
                  ${escapeHtml(distanceStatusText)}
                </p>
              </div>
            </div>
            <div class="store-locator__card-details" data-details-id="${index}" hidden>
              <div class="store-locator__card-details-content">
                <div class="store-locator__card-details-section">
                  <h4 class="store-locator__card-details-heading">Address</h4>
                  <p class="store-locator__card-full-address">${escapeHtml(fullAddress)}</p>
                </div>
                <div class="store-locator__card-details-section">
                  <h4 class="store-locator__card-details-heading">Phone</h4>
                  <p class="store-locator__card-phone">
                    <a href="tel:${location.phone.replace(/\D/g, '')}">${escapeHtml(location.phone)}</a>
                  </p>
                </div>
                ${locationHours && (!location.categories || location.categories.length <= 1) ? `
                <div class="store-locator__card-details-section">
                  <h4 class="store-locator__card-details-heading">Hours</h4>
                  ${(() => {
                    // Check if all days are "Open 24 Hours"
                    const allDays24_7 = dayKeys.every(key => locationHours[key] === 'Open 24 Hours');
                    if (allDays24_7) {
                      return '<p class="store-locator__card-hours-24-7">Open 24 Hours</p>';
                    } else {
                      return `<ul class="store-locator__card-hours-list">
                        ${dayKeys.map((key, i) => `<li><strong>${dayNames[i]}:</strong> ${escapeHtml(locationHours[key] || 'N/A')}</li>`).join('')}
                      </ul>`;
                    }
                  })()}
                </div>
                ` : ''}
                ${location.categories && location.categories.length > 1 ? `
                <div class="store-locator__card-details-section">
                  <h4 class="store-locator__card-details-heading">All Service Hours</h4>
                  ${location.categories.map(cat => {
                    const catHours = getHoursForCategory(location, cat);
                    if (!catHours) return '';
                    
                    // Check if all days are "Open 24 Hours" for this category
                    const allDays24_7 = dayKeys.every(key => catHours[key] === 'Open 24 Hours');
                    
                    if (allDays24_7) {
                      return `
                        <div style="margin-bottom: 1.6rem;">
                          <strong>${escapeHtml(cat)}:</strong>
                          <p style="margin-top: 0.4rem; margin-bottom: 0;">Open 24 Hours</p>
                        </div>
                      `;
                    } else {
                      return `
                        <div style="margin-bottom: 1.6rem;">
                          <strong>${escapeHtml(cat)}:</strong>
                          <ul class="store-locator__card-hours-list" style="margin-top: 0.4rem;">
                            ${dayKeys.map((key, i) => `<li><strong>${dayNames[i]}:</strong> ${escapeHtml(catHours[key] || 'N/A')}</li>`).join('')}
                          </ul>
                        </div>
                      `;
                    }
                  }).join('')}
                </div>
                ` : ''}
                <div class="store-locator__card-details-section">
                  <h4 class="store-locator__card-details-heading">Services</h4>
                  <p class="store-locator__card-services">${escapeHtml(location.services)}</p>
                </div>
                ${location.features && location.features.length > 0 ? `
                <div class="store-locator__card-details-section">
                  <h4 class="store-locator__card-details-heading">Features & Amenities</h4>
                  <div class="store-locator__card-features">
                    ${location.features.map(feature => {
                      return `<span class="store-locator__card-feature">${escapeHtml(feature)}</span>`;
                    }).join('')}
                  </div>
                </div>
                ` : ''}
                ${location.servicePage ? `<a href="${location.servicePage}" class="store-locator__card-directions button">View services</a>` : ''}
                <a href="${googleMapsUrl}" target="_blank" rel="noopener noreferrer" class="store-locator__card-directions button">
                  Get Directions
                </a>
              </div>
            </div>
          `;

          // Handle card hover for marker highlight (like Starbucks)
          card.addEventListener('mouseenter', async () => {
            if (map && markers[index]) {
              const targetMarker = markers[index];
              // Only change to hover icon if this marker is not currently selected
              if (targetMarker !== selectedMarker) {
                hoveredMarker = targetMarker;
                await setMarkerHovered(targetMarker);
              }
            }
          });
          
          card.addEventListener('mouseleave', async () => {
            if (map && markers[index]) {
              const targetMarker = markers[index];
              // Only revert hover if this marker is not selected
              if (targetMarker !== selectedMarker) {
                await setMarkerUnselected(targetMarker);
                if (hoveredMarker === targetMarker) {
                  hoveredMarker = null;
                }
              }
            }
          });

          // Handle card click for map update
          const cardMain = card.querySelector('.store-locator__card-main');
          cardMain.addEventListener('click', async (e) => {
            // Don't trigger if clicking the info button
            if (e.target.closest('.store-locator__card-info-btn')) return;
            selectedLocation = location;
            highlightCard(card);

            // Select marker using helper function
            if (map && markers[index]) {
              await selectLocationMarker(index, location, filteredLocations);
            }
          });

          // Handle info button click
          const infoBtn = card.querySelector('.store-locator__card-info-btn');
          const detailsPanel = card.querySelector('.store-locator__card-details');
          
          if (infoBtn && detailsPanel) {
            infoBtn.addEventListener('click', (e) => {
              e.stopPropagation();
              const isExpanded = infoBtn.getAttribute('aria-expanded') === 'true';
              infoBtn.setAttribute('aria-expanded', !isExpanded);
              detailsPanel.hidden = isExpanded;
              card.classList.toggle('is-expanded', !isExpanded);
              
              // Update map when expanding
              if (!isExpanded) {
                selectedLocation = location;
                highlightCard(card);

                // Select marker and optionally open info window if map is initialized
                if (map && markers[index]) {
                  (async () => {
                    await selectLocationMarker(index, location, filteredLocations);
                  })();
                }
              }
            });
          }

          listContainer.appendChild(card);
        });
      }

      // Google Maps instance and markers
      let map = null;
      let markers = [];
      let selectedMarker = null;
      let hoveredMarker = null; // Track currently hovered marker
      let autocomplete = null;
      let searchLocation = null; // Store the searched location coordinates
      
      // Create SVG marker icon as data URL
      // Create unselected marker circle (uses color and size from settings)
      async function createUnselectedMarkerPin() {
        await ensureGoogleLibraries();
        const size = markerSizeUnselected;
        const circleSize = size * 0.3125;
        const strokeWidth = 2;
        
        const div = document.createElement('div');
        div.style.width = `${size}px`;
        div.style.height = `${size}px`;
        div.style.display = 'flex';
        div.style.alignItems = 'center';
        div.style.justifyContent = 'center';
        
        const svg = `<svg width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg">
          <circle cx="${size/2}" cy="${size/2}" r="${circleSize/2}" fill="${markerColorUnselected}" stroke="#ffffff" stroke-width="${strokeWidth}"/>
        </svg>`;
        
        div.innerHTML = svg;
        return div;
      }
      
      // Create hovered marker circle (uses color and size from settings)
      async function createHoveredMarkerPin() {
        await ensureGoogleLibraries();
        const size = markerSizeHovered;
        const circleSize = size * 0.3125;
        const strokeWidth = 2;
        
        const div = document.createElement('div');
        div.style.width = `${size}px`;
        div.style.height = `${size}px`;
        div.style.display = 'flex';
        div.style.alignItems = 'center';
        div.style.justifyContent = 'center';
        
        const svg = `<svg width="${size}" height="${size}" xmlns="http://www.w3.org/2000/svg">
          <circle cx="${size/2}" cy="${size/2}" r="${circleSize/2}" fill="${markerColorHovered}" stroke="#ffffff" stroke-width="${strokeWidth}"/>
        </svg>`;
        
        div.innerHTML = svg;
        return div;
      }
      
      // Create selected marker circle (brand logo on colored background or colored circle)
      async function createSelectedMarkerPin() {
        await ensureGoogleLibraries();
        const svgSize = markerSizeSelected;
        const circleSize = svgSize * 0.5;
        const strokeWidth = 3;
        
        const div = document.createElement('div');
        div.style.width = `${svgSize}px`;
        div.style.height = `${svgSize}px`;
        div.style.display = 'flex';
        div.style.alignItems = 'center';
        div.style.justifyContent = 'center';

        // If brand logo is available, create SVG with logo on colored circle background
        if (brandLogoUrl && brandLogoUrl !== 'null' && brandLogoUrl.trim() !== '' && brandLogoUrl !== null) {
          const logoSize = Math.min(markerLogoSize, svgSize - 8);
          const logoUrl = brandLogoUrl.replace(/'/g, '');

          // Create SVG with colored circle and embedded logo image with glow effect
          const glowSize = svgSize * 0.875;
          const svg = `<svg width="${svgSize}" height="${svgSize}" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <circle cx="${svgSize/2}" cy="${svgSize/2}" r="${glowSize/2}" fill="${markerColorSelected}" opacity="0.3"/>
            <circle cx="${svgSize/2}" cy="${svgSize/2}" r="${circleSize/2}" fill="${markerColorSelected}" stroke="#ffffff" stroke-width="${strokeWidth}"/>
            <image x="${(svgSize - logoSize) / 2}" y="${(svgSize - logoSize) / 2}" width="${logoSize}" height="${logoSize}" href="${logoUrl}" xlink:href="${logoUrl}" preserveAspectRatio="xMidYMid meet" crossOrigin="anonymous"/>
          </svg>`;
          
          div.innerHTML = svg;
          return div;
        }

        // Otherwise, use colored circle with glow effect
        const glowSize = svgSize * 0.875;
        const svg = `<svg width="${svgSize}" height="${svgSize}" xmlns="http://www.w3.org/2000/svg">
          <circle cx="${svgSize/2}" cy="${svgSize/2}" r="${glowSize/2}" fill="${markerColorSelected}" opacity="0.3"/>
          <circle cx="${svgSize/2}" cy="${svgSize/2}" r="${circleSize/2}" fill="${markerColorSelected}" stroke="#ffffff" stroke-width="${strokeWidth}"/>
        </svg>`;
        
        div.innerHTML = svg;
        return div;
      }

      // Validate coordinates
      function validateCoordinates(lat, lng) {
        const latNum = parseFloat(lat);
        const lngNum = parseFloat(lng);
        
        if (isNaN(latNum) || isNaN(lngNum)) {
          return { valid: false, error: 'Invalid coordinate format' };
        }
        
        if (latNum < -90 || latNum > 90) {
          return { valid: false, error: 'Latitude must be between -90 and 90' };
        }
        
        if (lngNum < -180 || lngNum > 180) {
          return { valid: false, error: 'Longitude must be between -180 and 180' };
        }
        
        return { valid: true, lat: latNum, lng: lngNum };
      }

      // Calculate bounds for all locations
      function calculateBounds(locations) {
        if (!locations || locations.length === 0) {
          return null;
        }

        const validLocations = locations.filter(loc => {
          const validation = validateCoordinates(loc.lat, loc.lng);
          return validation.valid;
        });

        if (validLocations.length === 0) {
          return null;
        }

        const lats = validLocations.map(loc => {
          const validation = validateCoordinates(loc.lat, loc.lng);
          return validation.lat;
        });
        const lngs = validLocations.map(loc => {
          const validation = validateCoordinates(loc.lat, loc.lng);
          return validation.lng;
        });

        return {
          north: Math.max(...lats),
          south: Math.min(...lats),
          east: Math.max(...lngs),
          west: Math.min(...lngs)
        };
      }

      // Ensure required Google Maps libraries are loaded
      async function ensureGoogleLibraries() {
        try {
          // Import required libraries explicitly
          await google.maps.importLibrary('maps');
          await google.maps.importLibrary('marker');
          await google.maps.importLibrary('places');
          console.log('✓ Google Maps libraries loaded');
        } catch (error) {
          console.error('❌ Error loading Google Maps libraries:', error);
          throw error;
        }
      }

      // Initialize Google Maps with JavaScript API using dynamic library import
      async function initMap() {
        console.log('🗺️ Initializing Google Maps...');

        if (!mapContainer) {
          console.error('❌ Map container not found');
          updateMapEmbed(null, false, filteredLocations);
          return;
        }

        if (!filteredLocations || filteredLocations.length === 0) {
          console.warn('⚠️ No locations to display on map');
          showMapError('No locations configured. Please add location blocks in the theme editor.');
          return;
        }

        console.log('📍 Creating map with', filteredLocations.length, 'locations');

        try {
          // Ensure libraries are loaded before proceeding
          await ensureGoogleLibraries();

          // Libraries are now loaded via importLibrary
          const { Map } = await google.maps.importLibrary('maps');
          
          // Calculate initial bounds
          const bounds = calculateBounds(filteredLocations);
          const defaultCenter = { lat: 41.5, lng: -81.5 }; // Ohio area
          const defaultZoom = 10;

          // Initialize map with mapId (required for Advanced Markers)
          map = new Map(mapContainer, {
            center: bounds ? {
              lat: (bounds.north + bounds.south) / 2,
              lng: (bounds.east + bounds.west) / 2
            } : defaultCenter,
            zoom: bounds ? null : defaultZoom,
            mapId: googleMapsMapId,
            mapTypeControl: false,
            streetViewControl: false,
            fullscreenControl: true,
            zoomControl: true
            // Note: Custom styles are controlled via Cloud Console when using mapId
          });

          // Create markers for all locations (will use AdvancedMarkerElement)
          console.log('Creating markers for', filteredLocations.length, 'locations...');
          await createMarkers(filteredLocations);
          console.log('✓ Markers created:', markers.length);

          // Fit bounds to show all markers AFTER they're created
          // Use requestAnimationFrame for smooth rendering
          requestAnimationFrame(() => {
            setTimeout(() => {
              if (markers.length > 0) {
                fitBoundsToAllMarkers();
                console.log('✓ Map bounds fitted to show all', markers.length, 'markers');
                console.log('✅ Store Locator fully initialized!');
              } else {
                console.error('❌ ERROR: No markers were created despite having', filteredLocations.length, 'locations');
                console.error('Check console for marker creation errors');
              }
            }, 150);
          });

          // Autocomplete bounds are updated in initAutocomplete when map is ready

          console.log('Google Maps initialized with', markers.length, 'markers');
        } catch (error) {
          console.error('Error initializing Google Maps:', error);
          // Fallback to embed iframe
          updateMapEmbed(null, false, filteredLocations);
        }
      }

      // Create markers for locations using AdvancedMarkerElement
      async function createMarkers(locationsToShow) {
        // Clear existing markers
        clearMarkers();

        if (!map || !locationsToShow || locationsToShow.length === 0) {
          return;
        }

        try {
          // Ensure marker library is loaded
          await ensureGoogleLibraries();

          // Get marker library classes
          const markerLib = await google.maps.importLibrary('marker');
          const AdvancedMarkerElement = markerLib.AdvancedMarkerElement;
          const PinElement = markerLib.PinElement;

        for (const [index, location] of locationsToShow.entries()) {
          const validation = validateCoordinates(location.lat, location.lng);

          if (!validation.valid) {
            console.warn(`Skipping location "${location.name}": ${validation.error}`);
            continue;
          }

          try {
            const position = { lat: validation.lat, lng: validation.lng };

            // Create unique unselected circle for this marker (each marker needs its own DOM element)
            const unselectedPin = await createUnselectedMarkerPin();

            // Create AdvancedMarkerElement with circle content (unselected by default)
            const marker = new AdvancedMarkerElement({
              map: map,
              position: position,
              title: location.name,
              content: unselectedPin,
              zIndex: 1
            });

            // Store marker
            markers.push(marker);

            // Store reference to location for this marker
            marker._location = location;

            // Add click listener to marker
            marker.addListener('click', async () => {
              // Use helper function to select marker
              await selectLocationMarker(index, location, filteredLocations);

              // Re-sort list to put selected location at the top
              const selectedIndex = filteredLocations.findIndex(loc =>
                loc.name === location.name &&
                Math.abs(parseFloat(loc.lat) - parseFloat(location.lat)) < 0.0001 &&
                Math.abs(parseFloat(loc.lng) - parseFloat(location.lng)) < 0.0001
              );

              if (selectedIndex > 0) {
                // Move selected location to the top
                const selectedLoc = filteredLocations[selectedIndex];
                filteredLocations.splice(selectedIndex, 1);
                filteredLocations.unshift(selectedLoc);

                // Re-render the list with new order (this will update data-location-index)
                renderLocations(filteredLocations);
              }

              // Highlight corresponding card (find by location data, not index, since we just re-sorted)
              setTimeout(() => {
                // Find card by matching location data
                const cards = listContainer.querySelectorAll('.store-locator__card');
                let targetCard = null;
                cards.forEach(card => {
                  const cardLat = parseFloat(card.getAttribute('data-lat'));
                  const cardLng = parseFloat(card.getAttribute('data-lng'));
                  if (Math.abs(cardLat - parseFloat(location.lat)) < 0.0001 &&
                      Math.abs(cardLng - parseFloat(location.lng)) < 0.0001) {
                    targetCard = card;
                  }
                });

                if (targetCard) {
                  highlightCard(targetCard);
                  // Scroll card into view
                  targetCard.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                }
              }, 50);
            });

            // Store location index on marker for reference
            marker.locationIndex = index;
          } catch (error) {
            console.error(`Error creating marker for location "${location.name}":`, error);
          }
        }
        } catch (error) {
          console.error('Error creating markers:', error);
        }
      }

      // Helper function to update marker to unselected state
      async function setMarkerUnselected(marker) {
        if (!marker) return;
        const unselectedCircle = await createUnselectedMarkerPin();
        marker.content = unselectedCircle;
        marker.zIndex = 1;
      }

      // Helper function to update marker to hovered state
      async function setMarkerHovered(marker) {
        if (!marker) return;
        const hoveredCircle = await createHoveredMarkerPin();
        marker.content = hoveredCircle;
        marker.zIndex = 100;
      }

      // Helper function to update marker to selected state
      async function setMarkerSelected(marker) {
        if (!marker) return;
        const selectedCircle = await createSelectedMarkerPin();
        marker.content = selectedCircle;
        marker.zIndex = 1000;
      }

      // Helper function to fit map bounds to show all markers
      function fitBoundsToAllMarkers(padding = 50) {
        if (!map || !markers || markers.length === 0) {
          return;
        }

        const bounds = new google.maps.LatLngBounds();
        
        // Extend bounds with each marker's position
        markers.forEach(marker => {
          if (marker.position) {
            bounds.extend(marker.position);
          }
        });

        // Only fit bounds if we have valid bounds
        if (!bounds.isEmpty()) {
          map.fitBounds(bounds, {
            top: padding,
            right: padding,
            bottom: padding,
            left: padding
          });
          console.log('Map bounds fitted to show all', markers.length, 'markers');
        }
      }

      // Helper function to handle marker selection (reduces code duplication)
      async function selectLocationMarker(markerIndex, location, locationsArray) {
        if (!map || !markers || markerIndex < 0 || markerIndex >= markers.length) {
          return;
        }

        // Reset all markers to unselected state
        for (const m of markers) {
          if (markers.indexOf(m) !== markerIndex) {
            await setMarkerUnselected(m);
          }
        }

        // Set selected marker
        const targetMarker = markers[markerIndex];
        await setMarkerSelected(targetMarker);
        selectedMarker = targetMarker;
        hoveredMarker = null;

        // Update selected location
        selectedLocation = location;

        // Fit bounds to show all markers first
        fitBoundsToAllMarkers(mapBoundsPadding);

        // After fitting bounds, center on selected marker with zoom adjustment
        const validation = validateCoordinates(location.lat, location.lng);
        if (validation.valid) {
          const position = { lat: validation.lat, lng: validation.lng };
          setTimeout(() => {
            map.setCenter(position);
            const currentZoom = map.getZoom();
            if (locationsArray.length === 1) {
              map.setZoom(Math.max(currentZoom, 14));
            } else {
              map.setZoom(Math.max(currentZoom, 12));
            }
          }, 100);
        }
        
        if (!validation.valid && location) {
          // Fallback: just center on the selected location
          const validation = validateCoordinates(location.lat, location.lng);
          if (validation.valid) {
            map.setCenter({ lat: validation.lat, lng: validation.lng });
            map.setZoom(14);
          }
        }
      }

      // Clear all markers
      function clearMarkers() {
        // Remove markers from map
        markers.forEach(marker => {
          // AdvancedMarkerElement uses map property instead of setMap
          if (marker.map) {
            marker.map = null;
          }
        });

        markers = [];
        selectedMarker = null;
        hoveredMarker = null;
      }

      // Update markers when locations change
      async function updateMarkers(locationsToShow, skipFitBounds = false) {
        if (!map) {
          // Map not initialized yet, will be created in initMap
          return;
        }

        // Clear hover state when updating markers
        hoveredMarker = null;

        // Create markers (async)
        await createMarkers(locationsToShow);

        // Fit bounds to show all markers (unless skipping)
        if (!skipFitBounds) {
          // Get padding from config
          fitBoundsToAllMarkers(mapBoundsPadding);
        }
      }

      // Update map to show selected location
      async function updateMap(selectedLocation = null, centerOnUser = false, allLocations = null) {
        const locationsToShow = allLocations || filteredLocations || [];

        if (!map) {
          // Map not initialized, use embed fallback
          updateMapEmbed(selectedLocation, centerOnUser, locationsToShow);
          return;
        }

        try {
          if (selectedLocation) {
            const validation = validateCoordinates(selectedLocation.lat, selectedLocation.lng);
            if (validation.valid) {
              const position = { lat: validation.lat, lng: validation.lng };

              // Find and open marker for this location
              const markerIndex = markers.findIndex((marker, idx) => {
                const loc = locationsToShow[idx];
                return loc && loc.name === selectedLocation.name;
              });

              if (markerIndex !== -1) {
                // Use helper function to select marker
                (async () => {
                  await selectLocationMarker(markerIndex, selectedLocation, locationsToShow);
                })();
              }
            }
          } else if (centerOnUser && userLocation) {
            map.setCenter({ lat: userLocation.lat, lng: userLocation.lng });
            map.setZoom(13);
          } else {
            // Show all locations
            await updateMarkers(locationsToShow);
          }
        } catch (error) {
          console.error('Error updating map:', error);
          // Fallback to embed
          updateMapEmbed(selectedLocation, centerOnUser, locationsToShow);
        }
      }

      // Fallback: Update map using embed iframe
      function updateMapEmbed(selectedLocation = null, centerOnUser = false, allLocations = null) {
        if (!mapContainer) return;
        
        const locationsToShow = allLocations || filteredLocations || [];
        let mapUrl;
        let zoom = 12;
        
        if (selectedLocation) {
          // Build full address with all available fields
          const addressParts = [selectedLocation.address1];
          if (selectedLocation.address2) addressParts.push(selectedLocation.address2);
          if (selectedLocation.city || selectedLocation.state || selectedLocation.zip) {
            const cityStateZip = [selectedLocation.city, selectedLocation.state, selectedLocation.zip].filter(Boolean).join(' ');
            if (cityStateZip) addressParts.push(cityStateZip);
          }
          const fullAddress = addressParts.join(', ');
          const encodedAddress = encodeURIComponent(fullAddress);
          mapUrl = `https://www.google.com/maps?q=${encodedAddress}&output=embed&z=${zoom}`;
        } else if (centerOnUser && userLocation) {
          mapUrl = `https://www.google.com/maps?q=${userLocation.lat},${userLocation.lng}&output=embed&z=13`;
        } else if (locationsToShow.length > 0) {
          const avgLat = locationsToShow.reduce((sum, loc) => {
            const validation = validateCoordinates(loc.lat, loc.lng);
            return sum + (validation.valid ? validation.lat : 0);
          }, 0) / locationsToShow.length;
          const avgLng = locationsToShow.reduce((sum, loc) => {
            const validation = validateCoordinates(loc.lat, loc.lng);
            return sum + (validation.valid ? validation.lng : 0);
          }, 0) / locationsToShow.length;
          
          const lats = locationsToShow.map(loc => {
            const validation = validateCoordinates(loc.lat, loc.lng);
            return validation.valid ? validation.lat : null;
          }).filter(lat => lat !== null);
          const lngs = locationsToShow.map(loc => {
            const validation = validateCoordinates(loc.lat, loc.lng);
            return validation.valid ? validation.lng : null;
          }).filter(lng => lng !== null);
          
          if (lats.length > 0 && lngs.length > 0) {
            const minLat = Math.min(...lats);
            const maxLat = Math.max(...lats);
            const minLng = Math.min(...lngs);
            const maxLng = Math.max(...lngs);
            const latRange = maxLat - minLat;
            const lngRange = maxLng - minLng;
            const maxRange = Math.max(latRange, lngRange);
            
            if (maxRange > 0.5) zoom = 9;
            else if (maxRange > 0.2) zoom = 10;
            else if (maxRange > 0.1) zoom = 11;
            else zoom = 12;
            
            mapUrl = `https://www.google.com/maps?q=${avgLat},${avgLng}&output=embed&z=${zoom}`;
          } else {
            mapUrl = `https://www.google.com/maps?q=41.5,-81.5&output=embed&z=10`;
          }
        } else {
          mapUrl = `https://www.google.com/maps?q=41.5,-81.5&output=embed&z=10`;
        }
        
        const locationCount = selectedLocation ? 1 : locationsToShow.length;
        const locationText = selectedLocation ? escapeHtml(selectedLocation.name) : (locationCount + ' store location' + (locationCount !== 1 ? 's' : ''));
        
        mapContainer.innerHTML = `
          <iframe 
            src="${mapUrl}"
            width="100%" 
            height="100%" 
            style="border:0;" 
            allowfullscreen="" 
            loading="lazy" 
            referrerpolicy="no-referrer-when-downgrade"
            title="Map showing ${locationText}"
            aria-label="Interactive map showing ${locationText}"
          ></iframe>
        `;
      }

      // Highlight selected card
      function highlightCard(selectedCard) {
        const cards = listContainer.querySelectorAll('.store-locator__card');
        cards.forEach(card => card.classList.remove('is-selected'));
        selectedCard.classList.add('is-selected');
      }

      // Helper function to get hours for a specific category
      function getHoursForCategory(location, category) {
        if (!location.hours || typeof location.hours !== 'object') {
          return null;
        }
        
        // If category is specified and hours exist for that category, use it
        if (category && location.hours[category]) {
          return location.hours[category];
        }
        
        // Otherwise, use first available category's hours, or default
        const firstCategory = location.categories && location.categories.length > 0 ? location.categories[0] : null;
        if (firstCategory && location.hours[firstCategory]) {
          return location.hours[firstCategory];
        }
        
        // Fallback to default hours if available
        if (location.hours['default']) {
          return location.hours['default'];
        }
        
        return null;
      }

      // Debounce function for performance
      function debounce(func, wait) {
        let timeout;
        return function executedFunction(...args) {
          const later = () => {
            clearTimeout(timeout);
            func(...args);
          };
          clearTimeout(timeout);
          timeout = setTimeout(later, wait);
        };
      }

      // Filter and search locations
      async function filterLocations() {
        const searchTerm = (searchInput?.value || '').toLowerCase().trim();

        filteredLocations = locations.filter(location => {
          // Text search match
          const matchesSearch = !searchTerm ||
            location.name.toLowerCase().includes(searchTerm) ||
            location.address1.toLowerCase().includes(searchTerm) ||
            location.address2.toLowerCase().includes(searchTerm) ||
            location.services.toLowerCase().includes(searchTerm);

          // Category filter match
          const matchesCategory = !selectedCategory ||
            (location.categories && Array.isArray(location.categories) && location.categories.includes(selectedCategory));

          // Feature filter match - location must have ALL selected features
          const matchesFeatures = selectedFeatures.length === 0 ||
            (location.features && Array.isArray(location.features) &&
              selectedFeatures.every(selectedFeature =>
                location.features.some(locationFeature =>
                  locationFeature.toLowerCase() === selectedFeature.toLowerCase()
                )
              )
            );

          return matchesSearch && matchesCategory && matchesFeatures;
        });

        // Sort by distance (closest first)
        filteredLocations = sortLocationsByDistance(filteredLocations, searchLocation);

        renderLocations(filteredLocations);
        
        // Update map markers and zoom to show filtered locations
        if (map) {
          // Calculate bounds before updating markers
          let boundsToFit = null;
          if (filteredLocations.length > 0) {
            const bounds = calculateBounds(filteredLocations);
            if (bounds) {
              boundsToFit = new google.maps.LatLngBounds(
                new google.maps.LatLng(bounds.south, bounds.west),
                new google.maps.LatLng(bounds.north, bounds.east)
              );
            }
          }
          
          await updateMarkers(filteredLocations);
          
          // Zoom to show filtered locations after markers are updated
          fitBoundsToAllMarkers(mapBoundsPadding);
        } else if (filteredLocations.length > 0) {
          updateMap(null, false, filteredLocations);
        } else {
          updateMap(null, false, []);
        }
      }

      // Debounced version for search input
      const debouncedFilterLocations = debounce(filterLocations, 300);

      // Escape HTML
      function escapeHtml(text) {
        const div = document.createElement('div');
        div.textContent = text;
        return div.innerHTML;
      }

      // Update location button handler
      if (locationBtn) {
        locationBtn.addEventListener('click', async () => {
          // Disable button and show loading state
          locationBtn.disabled = true;
          const originalText = locationBtn.querySelector('.store-locator__location-btn-text')?.textContent || 'Use my location';
          const textSpan = locationBtn.querySelector('.store-locator__location-btn-text');
          if (textSpan) textSpan.textContent = 'Getting location...';
          
          try {
            // Clear searchLocation so filtering uses userLocation instead
            searchLocation = null;
            // Clear search input if there's text (since we're using user location now)
            if (autocomplete && autocomplete.value) {
              autocomplete.value = '';
            }
            if (searchInput && searchInput.value) {
              searchInput.value = '';
            }
            
            // Get user location (this will trigger permission prompt)
            userLocation = null;
            await getUserLocation();
            
            if (userLocation) {
              console.log('User location set:', userLocation);
              // Re-apply search and filter (which will sort by distance from user location)
              await filterLocations();
              // Update map markers and center on user location if we have filtered locations
              if (filteredLocations.length > 0) {
                if (map) {
                  await updateMarkers(filteredLocations);
                  // Center on user location
                  map.setCenter({ lat: userLocation.lat, lng: userLocation.lng });
                  map.setZoom(13);
                } else {
                  updateMap(null, true, filteredLocations);
                }
              }
              // Restore button text with success message
              if (textSpan) textSpan.textContent = 'Location updated';
              setTimeout(() => {
                if (textSpan) textSpan.textContent = originalText;
                locationBtn.disabled = false;
              }, 2000);
            } else {
              // Location denied or unavailable
              if (textSpan) textSpan.textContent = 'Location unavailable';
              setTimeout(() => {
                if (textSpan) textSpan.textContent = originalText;
                locationBtn.disabled = false;
              }, 2000);
            }
          } catch (error) {
            console.error('Error getting location:', error);
            if (textSpan) textSpan.textContent = 'Error getting location';
            setTimeout(() => {
              if (textSpan) textSpan.textContent = originalText;
              locationBtn.disabled = false;
            }, 2000);
          }
        });
      }

      // Event listeners
      if (searchInput) {
        // Handle manual text input (when not selecting from autocomplete)
        searchInput.addEventListener('input', (e) => {
          // Only clear searchLocation if user is manually typing (not from autocomplete selection)
          // This preserves search origin from autocomplete when user continues typing
          // The autocomplete gmp-select event will set searchLocation again when they select
          // Always allow text-based filtering to run (will use searchLocation if set, otherwise userLocation)
          debouncedFilterLocations(e);
        });
        searchInput.addEventListener('keydown', async (e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            // If autocomplete is available, let it handle selection
            // Otherwise fall back to text-based filtering
            if (!autocomplete) {
              await filterLocations();
            }
          }
        });
      }

      // Populate feature checkboxes
      function populateFeatureCheckboxes() {
        if (!filterFeaturesContainer || availableFeatures.length === 0) return;

        filterFeaturesContainer.innerHTML = availableFeatures.map((feature, index) => {
          const icon = getFeatureIcon(feature);
          const checkboxId = `feature-${sectionId}-${index}`;
          return `
            <label class="store-locator__filter-feature" for="${checkboxId}">
              <input
                type="checkbox"
                id="${checkboxId}"
                value="${escapeHtml(feature)}"
                data-feature="${escapeHtml(feature)}"
              >
              <span class="store-locator__filter-feature-label">
                ${icon ? `<span class="store-locator__filter-feature-icon">${icon}</span>` : ''}
                ${escapeHtml(feature)}
              </span>
            </label>
          `;
        }).join('');
      }

      // Initialize feature checkboxes
      populateFeatureCheckboxes();

      // Category pill click handlers
      if (categoryPills) {
        categoryPills.forEach(pill => {
          pill.addEventListener('click', async function() {
            const category = this.getAttribute('data-category');

            // Update selected category
            selectedCategory = category;

            // Update active state
            categoryPills.forEach(p => p.classList.remove('active'));
            this.classList.add('active');

            // Filter locations
            await filterLocations();
          });
        });
      }

      // Filter button toggle
      if (filterBtn && filterPanel) {
        filterBtn.addEventListener('click', function() {
          const isExpanded = filterPanel.hasAttribute('hidden');

          if (isExpanded) {
            filterPanel.removeAttribute('hidden');
            filterBtn.setAttribute('aria-expanded', 'true');
          } else {
            filterPanel.setAttribute('hidden', '');
            filterBtn.setAttribute('aria-expanded', 'false');
          }
        });
      }

      // Feature checkbox change handlers (update on change for live filtering)
      if (filterFeaturesContainer) {
        filterFeaturesContainer.addEventListener('change', async function(e) {
          if (e.target.type === 'checkbox') {
            // Update selected features array
            const checkboxes = filterFeaturesContainer.querySelectorAll('input[type="checkbox"]:checked');
            selectedFeatures = Array.from(checkboxes).map(cb => cb.getAttribute('data-feature'));

            // Apply filters immediately
            await filterLocations();
          }
        });
      }

      // Clear all filters button
      if (filterClearBtn && filterFeaturesContainer) {
        filterClearBtn.addEventListener('click', async function() {
          // Uncheck all feature checkboxes
          const checkboxes = filterFeaturesContainer.querySelectorAll('input[type="checkbox"]');
          checkboxes.forEach(cb => cb.checked = false);
          selectedFeatures = [];

          // Apply filters
          await filterLocations();
        });
      }

      // Apply filters button (close panel)
      if (filterApplyBtn && filterPanel) {
        filterApplyBtn.addEventListener('click', function() {
          filterPanel.setAttribute('hidden', '');
          if (filterBtn) {
            filterBtn.setAttribute('aria-expanded', 'false');
          }
        });
      }

      // Show map loading state
      function showMapLoading() {
        if (mapContainer) {
          mapContainer.innerHTML = `
            <div class="store-locator__map-loading">
              <div class="store-locator__map-loading-spinner"></div>
              <p>Loading map and locations...</p>
            </div>
          `;
        }
      }

      // Show map error state
      function showMapError(message) {
        if (mapContainer) {
          mapContainer.innerHTML = `
            <div class="store-locator__map-error">
              <p><strong>Unable to load map</strong></p>
              <p>${escapeHtml(message || 'Please check your Google Maps API key configuration.')}</p>
            </div>
          `;
        }
      }

      // Initialize Places Autocomplete using PlaceAutocompleteElement (current API)
      async function initAutocomplete() {
        if (!searchInput) {
          console.warn('Search input not found');
          return;
        }

        // Prevent duplicate initialization
        if (searchInput.dataset.autocompleteInitialized === 'true' || autocomplete) {
          console.log('Places Autocomplete already initialized');
          return;
        }

        try {
          // Ensure places library is loaded
          await ensureGoogleLibraries();

          // Use PlaceAutocompleteElement (current recommended API)
          const { PlaceAutocompleteElement } = await google.maps.importLibrary('places');
          
          // Create PlaceAutocompleteElement (it's a custom HTML element, not a wrapper)
          autocomplete = new PlaceAutocompleteElement({
            includedRegionCodes: ['us', 'ca'],
            requestedLanguage: 'en'
            // Removed includedPrimaryTypes to allow all types (cities, addresses, etc.)
          });

          // Style the autocomplete element to match the original input
          autocomplete.id = searchInput.id + '-autocomplete';
          autocomplete.style.width = '100%';
          autocomplete.placeholder = searchInput.placeholder || 'Enter city, zip code, or address';
          // Note: Padding, border, colors are handled in CSS for better control

          // Get parent wrapper
          const searchWrapper = searchInput.parentElement;

          if (searchWrapper) {
            // Hide original input (keep it for fallback)
            searchInput.style.position = 'absolute';
            searchInput.style.opacity = '0';
            searchInput.style.pointerEvents = 'none';
            searchInput.style.zIndex = '-1';

            // Insert autocomplete element before the hidden input
            searchWrapper.insertBefore(autocomplete, searchInput);

            // Remove Google's default icons after a brief delay (they render after insertion)
            setTimeout(() => {
              // Try to access shadow DOM and remove icons
              try {
                const shadowRoot = autocomplete.shadowRoot;
                if (shadowRoot) {
                  // Hide all icon elements in shadow DOM
                  const icons = shadowRoot.querySelectorAll('[class*="icon"], [role="presentation"], svg');
                  icons.forEach(icon => {
                    icon.style.display = 'none';
                  });
                }
              } catch (e) {
                // Shadow DOM might be closed, use CSS fallback
                console.log('Could not access shadow DOM for icon removal');
              }
            }, 100);
          }
          
          // Set location restriction to map bounds if map is initialized
          if (map) {
            const bounds = map.getBounds();
            if (bounds) {
              autocomplete.locationRestriction = bounds;
            }
          }

          // Listen for place selection (gmp-select event)
          autocomplete.addEventListener('gmp-select', async (event) => {
            try {
              console.log('Place selected from autocomplete');

              // Get Place object from the prediction
              const place = event.placePrediction.toPlace();

              // Fetch location field
              await place.fetchFields({ fields: ['location', 'displayName', 'formattedAddress'] });

              console.log('Place details:', {
                name: place.displayName,
                address: place.formattedAddress,
                location: place.location
              });

              if (!place.location) {
                console.warn('Selected place has no location');
                return;
              }

              // Store search location as the origin for distance sorting
              // Note: place.location is a LatLng object, so we need to call .lat() and .lng() methods
              searchLocation = {
                lat: typeof place.location.lat === 'function' ? place.location.lat() : place.location.lat,
                lng: typeof place.location.lng === 'function' ? place.location.lng() : place.location.lng
              };
              console.log('Search location set to:', searchLocation);
              console.log('Latitude:', searchLocation.lat, 'Longitude:', searchLocation.lng);

              // Update bounds restriction after selection
              if (map) {
                const bounds = map.getBounds();
                if (bounds) {
                  autocomplete.locationRestriction = bounds;
                }
              }

              // Filter and sort locations by distance from searched location
              console.log('Calling filterLocationsBySearchLocation...');
              await filterLocationsBySearchLocation(searchLocation);
            } catch (error) {
              console.error('Error handling place selection:', error);
            }
          });

          // Listen for manual text input on autocomplete element
          autocomplete.addEventListener('input', (e) => {
            // Allow text-based filtering when user types manually
            debouncedFilterLocations(e);
          });
          
          // Listen for Enter key on autocomplete element
          autocomplete.addEventListener('keydown', async (e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              // Enter key will trigger autocomplete selection if dropdown is open
              // If no selection is made, this prevents default form submission
            }
          });
          
          // Mark as initialized to prevent duplicates
          searchInput.dataset.autocompleteInitialized = 'true';
          console.log('Places Autocomplete (PlaceAutocompleteElement) initialized');
        } catch (error) {
          console.error('Error initializing Places Autocomplete:', error);
        }
      }

      // Filter locations by distance from search location
      async function filterLocationsBySearchLocation(searchLoc) {
        // Apply category and feature filters
        let filtered = locations.filter(location => {
          // Category filter
          const matchesCategory = !selectedCategory ||
            (location.categories && Array.isArray(location.categories) && location.categories.includes(selectedCategory));

          // Feature filter - location must have ALL selected features
          const matchesFeatures = selectedFeatures.length === 0 ||
            (location.features && Array.isArray(location.features) &&
              selectedFeatures.every(selectedFeature =>
                location.features.some(locationFeature =>
                  locationFeature.toLowerCase() === selectedFeature.toLowerCase()
                )
              )
            );

          return matchesCategory && matchesFeatures;
        });

        // Calculate distance for each location from search location
        filteredLocations = filtered.map(loc => {
          const validation = validateCoordinates(loc.lat, loc.lng);
          if (!validation.valid) {
            return { ...loc, distance: Infinity };
          }
          
          const distance = calculateDistance(
            searchLoc.lat,
            searchLoc.lng,
            validation.lat,
            validation.lng
          );
          
          return { ...loc, distance: distance };
        });

        // Sort by distance
        filteredLocations.sort((a, b) => {
          const distA = a.distance !== undefined ? a.distance : Infinity;
          const distB = b.distance !== undefined ? b.distance : Infinity;
          return distA - distB;
        });

        // Update markers first (without zooming)
        await updateMarkers(filteredLocations, true); // Pass true to skip fitBounds

        // Center map on search location with appropriate zoom AFTER markers are updated
        if (map && searchLoc) {
          console.log('Centering map on search location:', searchLoc);
          // Use setTimeout to ensure markers are rendered before zooming
          setTimeout(() => {
            console.log('Setting map center to:', searchLoc);
            map.setCenter(searchLoc);
            // Zoom based on how many locations we have nearby
            if (filteredLocations.length > 0 && filteredLocations[0].distance !== undefined) {
              // If closest location is within a few miles, zoom in more
              const closestDistance = filteredLocations[0].distance;
              console.log('Closest location distance:', closestDistance, 'miles');
              if (closestDistance < 1) {
                console.log('Setting zoom to 14 (very close)');
                map.setZoom(14); // Very close, zoom in
              } else if (closestDistance < 5) {
                console.log('Setting zoom to 12 (within 5 miles)');
                map.setZoom(12); // Within 5 miles, medium zoom
              } else {
                map.setZoom(11); // Further away, zoom out
              }
            } else {
              console.log('Setting zoom to 13 (default)');
              map.setZoom(13); // Default zoom
            }
            console.log('Map centered successfully');
          }, 150); // Increased delay to ensure markers are fully rendered
        } else {
          console.warn('Map or searchLoc not available:', { map: !!map, searchLoc: !!searchLoc });
        }

        // Update list
        renderLocations(filteredLocations);
      }

      // Initialize map when Google Maps API is ready
      function initializeWhenReady() {
        // Check for API key
        if (!googleMapsApiKey || googleMapsApiKey.trim() === '') {
          console.warn('Google Maps API key not configured');
          showMapError('Google Maps API key is not configured. Please add your API key in the theme editor.');
          renderLocations(filteredLocations);
          return;
        }

        // Check for API errors
        if (window.googleMapsError) {
          showMapError('Google Maps API authentication failed. Please check your API key.');
          renderLocations(filteredLocations);
          return;
        }

        // Check if google.maps.importLibrary is available (from bootstrap loader)
        if (typeof google !== 'undefined' && google.maps && typeof google.maps.importLibrary === 'function') {
          (async () => {
            await initMap();
            await initAutocomplete();
            renderLocations(filteredLocations);
          })();
        } else if (window.googleMapsReady) {
          (async () => {
            await initMap();
            await initAutocomplete();
            renderLocations(filteredLocations);
          })();
        } else {
          // Show loading state
          showMapLoading();
          
          // Wait for Google Maps to load
          const handleMapsLoaded = async () => {
            if (window.googleMapsError) {
              showMapError('Google Maps API authentication failed. Please check your API key.');
              renderLocations(filteredLocations);
              return;
            }
            await initMap();
            await initAutocomplete();
            renderLocations(filteredLocations);
          };
          
          const handleMapsError = () => {
            showMapError('Google Maps API failed to load. Please check your API key and network connection.');
            renderLocations(filteredLocations);
          };
          
          document.addEventListener('googlemapsloaded', handleMapsLoaded);
          document.addEventListener('googlemapserror', handleMapsError);
          
          // Fallback: check periodically (in case event didn't fire)
          let attempts = 0;
          const checkInterval = setInterval(() => {
            attempts++;
            if (window.googleMapsError) {
              clearInterval(checkInterval);
              document.removeEventListener('googlemapsloaded', handleMapsLoaded);
              document.removeEventListener('googlemapserror', handleMapsError);
              handleMapsError();
            } else if (typeof google !== 'undefined' && google.maps && typeof google.maps.importLibrary === 'function') {
              clearInterval(checkInterval);
              document.removeEventListener('googlemapsloaded', handleMapsLoaded);
              document.removeEventListener('googlemapserror', handleMapsError);
              console.log('✓ Google Maps importLibrary ready, initializing...');
              (async () => {
                await initMap();
                await initAutocomplete();
                // Always render the location list
                renderLocations(filteredLocations);
              })();
            } else if (attempts > 20) {
              // Give up after 10 seconds and use fallback
              clearInterval(checkInterval);
              document.removeEventListener('googlemapsloaded', handleMapsLoaded);
              document.removeEventListener('googlemapserror', handleMapsError);
              console.warn('Google Maps API failed to load, using fallback');
              updateMapEmbed(null, false, filteredLocations);
              renderLocations(filteredLocations);
            }
          }, 500);
        }
      }

      // Initialize with all locations (sorted by distance if user location available)
      try {
        console.log('=== Store Locator Initialization ===');
        console.log('Total locations loaded:', locations.length);
        console.log('Filtered locations:', filteredLocations.length);

        if (filteredLocations.length === 0) {
          console.warn('⚠️ Store Locator: No locations to display');
          console.warn('Please add location blocks in the Shopify theme editor');
          // Show message in the list
          if (listContainer) {
            listContainer.innerHTML = '<div class="store-locator__no-results"><p><strong>No locations configured</strong></p><p>Please add location blocks in the theme editor to display on the map.</p></div>';
          }
        } else {
          console.log('✓ Locations ready, initializing map...');
          initializeWhenReady();
        }
      } catch (error) {
        console.error('❌ Store Locator: Error initializing locations', error);
        if (listContainer) {
          listContainer.innerHTML = '<div class="store-locator__no-results"><p>Error loading locations. Please refresh the page.</p></div>';
        }
      }
    }

    // Initialize on DOM ready
    try {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', startStoreLocator);
      } else {
        startStoreLocator();
      }
    } catch (error) {
      console.error('Store Locator: Fatal error', error);
    }

    // Re-initialize on section load (for theme editor)
    document.addEventListener('shopify:section:load', function(event) {
      if (event.detail.sectionId === sectionId) {
        // Re-initialize this section
        const configScript = document.getElementById('StoreLocatorConfig-' + sectionId);
        const dataScript = document.getElementById('StoreLocatorData-' + sectionId);
        if (configScript && dataScript) {
          try {
            const config = JSON.parse(configScript.textContent);
            const rawData = JSON.parse(dataScript.textContent);
            initStoreLocator(sectionId, config, rawData);
          } catch (error) {
            console.error('Store Locator: Error re-initializing section', sectionId, error);
          }
        }
      }
    });
  }

  // Initialize all store locators when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAllStoreLocators);
  } else {
    initAllStoreLocators();
  }
})();
